import { LoginForm } from './LoginForm';
import { useAuth } from '../hooks/useAuth';
import { Navigate, useLocation } from 'react-router-dom';
import { CenteredLayout } from '@/components/layout/CenteredLayout';

export function LoginPage() {
  const { session } = useAuth();
  const location = useLocation();

  // If user is already authenticated, redirect to the intended page or dashboard
  if (session.isAuthenticated) {
    const from = location.state?.from?.pathname || '/';
    return <Navigate to={from} replace />;
  }

  // Show loading state
  if (session.isLoading) {
    return (
      <CenteredLayout
        title="Loading..."
        subtitle="Please wait while we verify your session."
      >
        <div />
      </CenteredLayout>
    );
  }

  return (
    <CenteredLayout>
      <LoginForm />
    </CenteredLayout>
  );
} 